import React, { useState } from 'react';
import './imageCard.scss';
import { useNavigate, useLocation } from 'react-router-dom';

interface ImageCardProps {
  imageUrl: string;
  title: string;
  learnMoreLink: string;
}

const ImageCard: React.FC<ImageCardProps> = ({ imageUrl, title, learnMoreLink }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // If already on services page, just scroll
    if (location.pathname === '/services') {
      const element = document.getElementById(learnMoreLink);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to services page with hash
      navigate(`/services#${learnMoreLink}`);
    }
  };

  return (
    <div
      className="image-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <div className={`overlay ${isHovered ? 'overlay-dark' : ''}`}>
        <div className="content">
          <h2 className="title">{title}</h2>
          <button 
            onClick={handleClick}
            className={`learn-more-link ${isHovered ? 'visible' : ''}`}
          >
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageCard;